module.exports = "/_next/static/images/6bb938c16f6041b98882da81bfb55a37-savingsPlant.svg.webp";